import React from 'react';

function StatCard({ icon: Icon, label, value, subValue, gradient }) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 hover:shadow-md transition-shadow duration-200">
      <div className="flex items-center gap-3">
        <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${gradient} flex items-center justify-center shadow-md flex-shrink-0`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs text-slate-600 font-montserrat mb-0.5">{label}</p>
          <p className="text-xl font-bold text-slate-900 font-montserrat truncate">{value}</p>
          {subValue && (
            <p className="text-xs text-slate-500 font-montserrat">{subValue}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default StatCard;